import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ReferralUrlService } from '../../../../features/sales/services/referral-url.service';
import { isPlatformBrowser } from '@angular/common';
import { SalesService } from '../../../../features/sales/services/sales-agent.service';

@Component({
  selector: 'app-referral-handler',
  template: '',
})
export class ReferralHandlerComponent implements OnInit {
    route = inject(ActivatedRoute);
  router = inject(Router);
  http = inject(HttpClient);
    referralService = inject(ReferralUrlService);
    salesService = inject(SalesService);
  platformId = inject(PLATFORM_ID);
  constructor(
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    const slug = this.route.snapshot.paramMap.get('slug');
    
    // Leaving this log here for your peace of mind!
    console.log('Captured slug:', slug);

    if (slug) {
      // We ONLY rely on the service now. No synchronous redirects above this line.
      this.referralService.getAgentCodeByReferralUrl(slug).subscribe({
        next: (agentCode) => {
          console.log('Successfully fetched agent code:', agentCode);
          this.setCookieAndRedirect(agentCode);
        },
        error: (err) => {
          console.error('Failed to lookup referral slug. Redirecting anyway.', err);
          this.router.navigate(['/host']);
        }
      });
    } else {
      this.router.navigate(['/host']);
    }
}
  }

  private setCookieAndRedirect(agentId: string): void {
    const maxAge = 86400 * 30; // 30 days
    document.cookie = `referral_agent_id=${agentId}; path=/; max-age=${maxAge}; SameSite=Lax`;
    this.salesService.trackReferralClick(agentId);
    this.router.navigate(['/host']);
  }
}